import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';

const ApplyJob = () => {
    const [jobsData, setJobsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 5;

    useEffect(() => {
        // Fetch the data from the API when the component mounts
        const fetchJobsData = async () => {
            try {
                const response = await axios.get('https://api.biznetusa.com/api/get-apply-for-job');
                if (response.status === 200) {
                    setJobsData(response.data.all_jobs || []);
                } else {
                    setError('Failed to fetch data');
                }
                setLoading(false);
            } catch (err) {
                setError('An error occurred while fetching data');
                setLoading(false);
            }
        };

        fetchJobsData();
    }, []);

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`https://api.biznetusa.com/api/deleteapplyforjob/${id}`);
            if (response.status === 200) {
                // Update the jobs data by removing the deleted item
                setJobsData(prevJobsData => prevJobsData.map(job => ({
                    ...job,
                    myinfo: job.myinfo.filter(info => info.id !== id)
                })).filter(job => job.myinfo.length > 0));

                toast.success('Job deleted successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                });
            } else {
                toast.error('Failed to delete job.', {
                    position: "top-right",
                    autoClose: 3000,
                });
            }
        } catch (err) {
            toast.error('An error occurred while trying to delete the job.', {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    // Calculate the indices for pagination
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = jobsData.flatMap(job => job.myinfo).slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(jobsData.flatMap(job => job.myinfo).length / recordsPerPage);

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    // Render loading, error, or table based on state
    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Job Requests</h2>
            <table className="table table-bordered overflow-x-scroll">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Country</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zipcode</th>
                        <th>Preferred Name</th>
                        <th>Address Line 1</th>
                        <th>Address Line 2</th>
                        <th>About Us</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentRecords.length > 0 ? (
                        currentRecords.map((info) => (
                            <tr key={info.id}>
                                <td>{info.id}</td>
                                <td>{info.f_name}</td>
                                <td>{info.l_name}</td>
                                <td>{info.email}</td>
                                <td>{info.phone}</td>
                                <td>{info.country}</td>
                                <td>{info.city}</td>
                                <td>{info.state}</td>
                                <td>{info.zipcode}</td>
                                <td>{info.preferred_name}</td>
                                <td>{info.address_line_1}</td>
                                <td>{info.address_line_2}</td>
                                <td>{info.how_you_hear_about_us}</td>
                                <td>
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleDelete(info.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="14" className="text-center">No data available</td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Pagination */}
            <div className="d-flex justify-content-center mt-3">
                <button
                    className={`btn btn-outline-primary mx-1 ${currentPage === 1 ? 'disabled' : ''}`}
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        className={`btn btn-outline-primary mx-1 ${currentPage === index + 1 ? 'active' : ''}`}
                        onClick={() => handlePageChange(index + 1)}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    className={`btn btn-outline-primary mx-1 ${currentPage === totalPages ? 'disabled' : ''}`}
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default ApplyJob;
